.bam-image-teaser-wide__container {
  height: fit-content;
  display: grid;
  grid-template-areas: 'teaser';
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  // margin-bottom: 120px;
}

.bam-image-teaser-wide__image {
  grid-area: teaser;

  &.is-touch {
    pointer-events: none;

    @include desktop {
      pointer-events: all;
    }
  }
}

.bam-image-teaser-wide__box {
  margin: -48px 16px 0;
  z-index: 1;

  @include tablet {
    &[app-boxLocation='left'] {
      margin: -150px 0 0 32px;
    }
    &[app-boxLocation='right'] {
      margin: -150px 32px 0 auto;
      margin-left: auto !important;
    }
  }

  @include desktop {
    &[app-boxLocation='left'] {
      margin: -190px 0 0 72px;
    }
    &[app-boxLocation='right'] {
      margin: -190px 72px 0 auto;
      margin-left: auto !important;
    }
  }
}

.bam-image-teaser-wide__heading {
  margin-bottom: 32px !important;
}
